import { Container , Grow , Grid , Paper , AppBar , TextField ,Button  } from '@mui/material';
import TagsInput from './TagsInput';
import Posts from '../Posts/Posts';
import Form from '../Form/Form';
import Paginate from '../Pagination/Pagination' ;
import { useDispatch} from 'react-redux';
import {useNavigate,useLocation} from 'react-router-dom' ;
import { useState } from 'react';
import {getPostsBySearch} from '../../actions/posts'; 
 
const Home = () => {
    /* state to store id of a specific post , so we can pass it to both Post & Form components 
    (instead of creating a separate reducer , we uplift the state because Post & Form aren't in the same component ) */
  const [currentId, setCurrentId] = useState(null);
  
  const navigate = useNavigate() ;            //getting the navigate hook (to redirect routes automatically)    
  const dispatch = useDispatch();          //getting the dispatch hook 

  const [search, setSearch] = useState('');      //state for search memories posts input
  const [tags, setTags] = useState([]);          //state for search tags chip-input
  
  const searchPost =() =>{             //function when we click search button
    if (search.trim() || tags) {       //check if there's a search value , note:trim to remove empty space
      dispatch(getPostsBySearch({ search, tags: tags.join(',') }));    //note:convert tags to strings instead of array so we can pass it to the url
      navigate(`/posts/search?searchQuery=${search || 'none'}&tags=${tags.join(',')}`);
    } else {
      navigate('/');
    }
  }
  const handleKeyDown =(e) =>{                  //function for search-posts input if we press [Enter]
     if (e.keyCode === 13) { 
      searchPost();
     }
  }     
   
  const useQuery = () => new URLSearchParams(useLocation().search); //URLSearchParams used to get url Query params
  const query = useQuery();                //getting the query hook
  const page = query.get('page') || 1 ;     //getting the current page for the pagination , the default is 1
  const searchQuery = query.get('searchQuery') ;  //getting the search term
   
  return (
    //creating our home page component using material ui components 
    <Grow in>
            <Container maxWidth='xl'>                                           
              <div className='mquery'>

               <Grid item xs={12} sm={6} md={9} sx={{padding:'0 15px'}}>
                  <Posts setCurrentId={setCurrentId}/>
               </Grid>

               <Grid item xs={12} sm={6} md={3} sx={{marginBottom:'15px'}}>
                  <AppBar sx={{ borderRadius: 4, marginBottom: '1rem', display: 'flex',padding: '16px',}} color='inherit' position='static' >
                    <TextField value={search} onChange={(e)=>{setSearch(e.target.value)}} onKeyDown={handleKeyDown} name="search" variant='outlined' label='Search Memories' fullWidth />                 
                    <TagsInput selectedTags={(items)=>{setTags(items)}} fullWidth variant="outlined" id="tags" name="tags" placeholder="Search tags" sx={{margin:'10px 0'}} />             
                    <Button onClick={searchPost} color='primary' variant='contained'>Search</Button>
                  </AppBar>                  
                  <Form currentId={currentId} setCurrentId={setCurrentId}/>
                  {(!searchQuery && !tags.length) && (
                  <Paper elevation={6} sx={{margin:'15px',padding:'8px'}}> 
                      <Paginate page={page} /> 
                  </Paper>  )}
               </Grid>
               
               </div>                                                                                 
            </Container>
    </Grow>
  )
}

export default Home